import React, { ForwardedRef, MouseEvent, PropsWithChildren, ReactChild, RefObject } from "react"
import styled from "styled-components"

interface Props {
  className?: string
  id?: string
  disabled?: boolean | (() => boolean)
  onClick?: (event: MouseEvent<HTMLButtonElement> | any) => any | null
  children?: ReactChild | ReactChild[]
  ref?: RefObject<HTMLButtonElement>
  type?: string
}

export default React.forwardRef(
  (
    { onClick = null, className = "", disabled = false, children, type }: PropsWithChildren<Props>,
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <Button
        type={type}
        ref={ref}
        className={`btn ${className} ${disabled ? "disabled" : ""}`}
        disabled={typeof disabled === "function" ? disabled?.call(this) : disabled}
        onClick={onClick}
      >
        {children}
      </Button>
    )
  }
)

const Button = styled.button`
  :disabled {
    color: #eee !important;
    background-color: #939393 !important;
    border-color: #939393 !important;
  }

  color: #fff;
  text-align: center;
  display: block;
  border: none;
  border-radius: 30px;
  cursor: pointer;

  border-radius: 35px;

  button:hover {
    text-decoration: none;
  }

  &.btn-ledger {
    width: 25% !important;
  }

  &.btn {
    display: block;
  }

  &.btn-conversion,
  &.btn-delete,
  &.btn-common,
  &.btn-back,
  &.btn-top {
    display: block;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    width: 100%;
    max-width: 315px;
    margin: 0 auto;
    padding: 18px 20px;
  }

  &.btn-back:hover {
    color: #222222 !important;
  }
  &.btn-delete {
    display: block;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    width: 100%;
    max-width: 350px;
    margin: 0 auto;
    padding: 10px 10px;
  }
  &.btn-conversion,
  &.btn-delete,
  &.btn-common {
    border: 2px solid #6b6bf9;
  }

  &.btn.btn-logout,
  &.btn.btn-logout:hover {
    font-weight: normal;
    padding: 8px 12px;
    color: #fff;
    background-color: #4f4ce6;
    border-radius: 25px;
    font-size: 15px;
    width: 152px;
  }

  &.resister-btn {
    display: block;
    padding: 18px 20px;
    font-weight: bold;
    color: #6b6bf9;
    background-color: #fff;
    /*background-image: url(/images/ico-plus.png);*/
    background-repeat: no-repeat;
    background-position: 30px center;
    background-size: 14px;
    border: 2px solid #6b6bf9;
  }

  &.btn:hover {
    color: #fff;
  }

  &.btn:focus {
    box-shadow: none;
  }

  &.resister-btn:hover {
    color: #6b6bf9;
  }

  &.btn-top:hover,
  .btn-back:hover {
    color: #6b6bf8;
  }

  &.btn-conversion:hover,
  &.btn-delete:hover,
  &.btn-common:hover {
    text-decoration: none;
    transition: 0.2s;
  }

  &.btn-common:hover {
    color: #6b6bf9;
    background-color: #ffffff;
  }

  &.btn-conversion {
    color: #fff;
    background-color: #6b6bf9;
    position: relative;
  }

  &.btn-common {
    color: #6b6bf9;
    background-color: #ffffff;
  }

  &.btn-back,
  &.btn-next {
    position: relative;
    padding-left: 42px;
    padding-right: 42px;
  }

  &.btn-back,
  &.btn-back:hover {
    color: #222222;
    background-color: #ecedf1;
  }

  &.btn-danger,
  &.btn-delete {
    color: #ffffff;
    background-color: #f02626;
    border: 2px solid #f02626;

    :hover {
      color: #f02626;
    }
  }

  &.btn-top,
  &.btn-top:hover {
    color: #6b6bf8;
    background-color: #cfd4fb;
    position: relative;
  }

  &.btn-conversion-round,
  &.btn-common-round {
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    display: block;
    width: 100%;
    max-width: 240px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    padding: 12px 16px;
    border: 2px solid #6b6bf9;
  }

  &.btn-conversion-round {
    color: #fff;
    background-color: #6b6bf9;
  }

  &.btn-next::after {
    transform: rotate(45deg);
    top: calc(50% - 7px);
    right: 20px;
  }

  &.btn-conversion-round {
    color: #fff;
    background-color: #6b6bf9;
  }
  &.btn-register {
    color: white;
    background-color: black;
    border: none;
  }
  &.btn-register:hover {
    color: white;
    background-color: black;
    border: none;
  }
`
